import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "../styles/ProjectDetailsPage.scss";
import { motion, AnimatePresence } from "framer-motion";

interface EventImage {
  url: string;
  caption: string;
}

const ProjectDetailsPage: React.FC = () => {
  const { eventId } = useParams();
  const [images, setImages] = useState<EventImage[]>([]);
  const [eventTitle, setEventTitle] = useState<string>("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvent = async () => {
      if (!eventId) return;
      const docRef = doc(db, "events", eventId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setImages(data.images || []);
        setEventTitle(data.event || "Event");
      }
    };
    fetchEvent();
  }, [eventId]);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="project-details-page fullscreen-slider">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back to Projects
      </button>

      <h1>{eventTitle}</h1>

      {images.length > 0 && (
        <>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              className="slider-image-wrapper"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6 }}
            >
              <img src={images[currentIndex].url} alt={`Slide ${currentIndex}`} />
              {images[currentIndex].caption && (
                <p className="caption">{images[currentIndex].caption}</p>
              )}
            </motion.div>
          </AnimatePresence>

          <button className="nav-btn left" onClick={prevImage}>‹</button>
          <button className="nav-btn right" onClick={nextImage}>›</button>
        </>
      )}
    </div>
  );
};

export default ProjectDetailsPage;
